import React, { useState, useRef } from "react";
import AsyncSelect from 'react-select/async';

import "./SelectMdpId.styles.sass";

interface Client {
  name: string,
  id: string
};

const SelectMdpId = (props: any) => {
  const [client, setClient] = useState<string | null>(props.defaultValue);
  let timer = useRef<unknown>();

  const loadOptions = (value, callback) => {
    clearTimeout(timer.current as number);

    timer.current = setTimeout(() => {
      props.loadOptions(value)
      .then((success) => {
        callback(success);
      }, (error) => {
        callback(error);
      });
    }, 500);
  }

  return <AsyncSelect
    cacheOptions
    {...props}
    loadOptions={loadOptions}
    onChange={(item: any) => {props.setClientFromMdp(item); setClient((): string | null => item ? `${item.name} (${item.id})` : null);}}
    value={{ label: client ? client  : '' }}
    isClearable={true}
    className="react-select-container"
    classNamePrefix="react-select"
    required={props.required}
  />;
};

export default SelectMdpId;
